export default {
  lstWatchlist: {
    ticker: 'TICKER',
    anDate: 'AN.DATE',
    title: 'TITLE',
    recordDate: 'RECORD DATE',
    ex: 'EX-RIGHT DATE',
    excercise: 'EXERCISE DATE',
    eventType: 'EVENT TYPE',
    reference: 'REFERENCE',
  },
  lstTitleDate: {
    anDate: 'An.Date',
    recordDate: 'Record Date',
    exRigth: 'Ex-Right Date',
    excersise: 'Exercise Date',
  },
  all: 'All',
  ern: 'Earning',
  div: 'Dividend',
  sis: 'Share Issuance',
  ipo: 'Listing',
  agm: 'AGM',
  eventType: 'Event Type',
  anDate: 'Announcement',
  recordDate: 'Record',
  exRightDate: 'Ex-Rights',
  excerciseDate: 'Exercise',
  apply: 'Apply',
  reset: 'reset',
  to: 'To',
  notAvailable: 'URL Not Available',
  startDate: 'START DATE',
  endDate: 'END DATE',
};
